import { useMemo } from "react";
import { Flex, Select, FormItem, Button } from "@/base/components/index";
import { useFormWatch } from "@/base/utils/index";
import { LocalizationText } from "@/app/index";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";

export const ModalHardwareInstallCRBrandSelectActions = () => {
  const { form, fetchBackDrawerPage } = useContextModalHardwareInstall();

  const handleButtonClick = () => {
    form.validateFields().then(() => {
      form.submit();
    });
  };

  return (
    <Flex vertical gap={8} align="stretch">
      <Button block size="large" type="primary" onClick={handleButtonClick}>
        <LocalizationText value="modal.subscription.assign.button.done.text" />
      </Button>

      <Button
        block
        size="large"
        type="default"
        onClick={() => fetchBackDrawerPage()}
      >
        <LocalizationText value="modal.hardware.install.button.back.text" />
      </Button>
    </Flex>
  );
};

export const ModalHardwareInstallCRBrandSelect = () => {
  const { deploymentData, form } = useContextModalHardwareInstall();
  const cashRegisterBrandId = useFormWatch("CashRegisterBrandId", form);

  const cashRegisterModelItems = useMemo(() => {
    return deploymentData?.CashRegisters?.find(
      (item) => item.Id === cashRegisterBrandId,
    )?.Items?.map((item) => ({
      label: item.Name,
      value: item.Id,
    }));
  }, [cashRegisterBrandId, deploymentData?.CashRegisters]);

  return (
    <Flex vertical align="stretch">
      <FormItem
        rules={[{ required: true }]}
        label={
          <LocalizationText value="modal.subscription.assign.cash.register.brand.name.input.label.text" />
        }
        name="CashRegisterBrandId"
      >
        <Select
          size="large"
          onChange={() => form.resetFields(["CashRegisterModelId"])}
          options={deploymentData?.CashRegisters?.map((item) => ({
            label: item.Name,
            value: item.Id,
          }))}
        />
      </FormItem>

      <FormItem
        rules={[{ required: !!cashRegisterModelItems?.length }]}
        label={
          <LocalizationText value="modal.subscription.assign.cash.register.brand.name.input.label.text" />
        }
        name="CashRegisterModelId"
      >
        <Select
          size="large"
          disabled={!cashRegisterBrandId || !cashRegisterModelItems?.length}
          options={cashRegisterModelItems}
        />
      </FormItem>
    </Flex>
  );
};
